module.exports = __webpack_public_path__ + "img/Showers.3f605163.png";